import React from 'react'
import moment from 'moment'
import { HomeOutlined, WalletOutlined } from '@ant-design/icons'
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import { FcAutomotive } from 'react-icons/fc'
import { GiPerspectiveDiceSixFacesRandom } from 'react-icons/gi'
import {
  addressController,
  carController,
  companyController,
  defaultController,
  userController,
  systemController,
  productController,
  colorController,
  titlesController,
} from '../../apiServices'
import {
  // installmentPrice,
  isValidResponse,
  numberWithCommas,
  redirect,
} from '../functions'
import { ROUTE_PATH } from './routes'

export const LIST = {
  BANKSINVOICE: async () => {
    const API = defaultController()
    const res = await API.getBank()
    if (isValidResponse(res)) {
      const banks = res.result
      const banksOption = banks.map((e, i) => {
        return {
          key: i,
          value: e.bankname,
          text: `${e.bank_no} ${e.bankname}`,
        }
      })
      return banksOption
    }
  },
  BANKS: async () => {
    return [
      {
        key: 0,
        value: 'ธนาคารไทยพาณิชย์',
        text: `165-267459-4 ธนาคารไทยพาณิชย์`,
      },
    ]
    // const API = defaultController()
    // const res = await API.getBank()
    // if (isValidResponse(res)) {
    // 	const banks = res.result
    // 	const banksOption = banks.map((e, i) => {
    // 		return {
    // 			key: i,
    // 			value: e.bankname,
    // 			text: `${e.bank_no} ${e.bankname}`,
    // 		}
    // 	})
    // 	return banksOption
    // }
  },
  GENDER: [
    { key: '1', value: 'M', text: 'ชาย' },
    { key: '2', value: 'F', text: 'หญิง' },
  ],
  DAY: [
    { key: '1', value: '01', text: '1' },
    { key: '2', value: '02', text: '2' },
    { key: '3', value: '03', text: '3' },
    { key: '4', value: '04', text: '4' },
    { key: '5', value: '05', text: '5' },
    { key: '6', value: '06', text: '6' },
    { key: '7', value: '07', text: '7' },
    { key: '8', value: '08', text: '8' },
    { key: '9', value: '09', text: '9' },
    { key: '10', value: '10', text: '10' },
    { key: '11', value: '11', text: '11' },
    { key: '12', value: '12', text: '12' },
    { key: '13', value: '13', text: '13' },
    { key: '14', value: '14', text: '14' },
    { key: '15', value: '15', text: '15' },
    { key: '16', value: '16', text: '16' },
    { key: '17', value: '17', text: '17' },
    { key: '18', value: '18', text: '18' },
    { key: '19', value: '19', text: '19' },
    { key: '20', value: '20', text: '20' },
    { key: '21', value: '21', text: '21' },
    { key: '22', value: '22', text: '22' },
    { key: '23', value: '23', text: '23' },
    { key: '24', value: '24', text: '24' },
    { key: '25', value: '25', text: '25' },
    { key: '26', value: '26', text: '26' },
    { key: '27', value: '27', text: '27' },
    { key: '28', value: '28', text: '28' },
    { key: '29', value: '29', text: '29' },
    { key: '30', value: '30', text: '30' },
    { key: '31', value: '31', text: '31' },
  ],
  MONTH: [
    { key: '1', value: '01', text: 'มกราคม' },
    { key: '2', value: '02', text: 'กุมภาพันธ์' },
    { key: '3', value: '03', text: 'มีนาคม' },
    { key: '4', value: '04', text: 'เมษายน' },
    { key: '5', value: '05', text: 'พฤษภาคม' },
    { key: '6', value: '06', text: 'มิถุนายน' },
    { key: '7', value: '07', text: 'กรกฎาคม' },
    { key: '8', value: '08', text: 'สิงหาคม' },
    { key: '9', value: '09', text: 'กันยายน' },
    { key: '10', value: '10', text: 'ตุลาคม' },
    { key: '11', value: '11', text: 'พฤศจิกายน' },
    { key: '12', value: '12', text: 'ธันวาคม' },
  ],
  YEAR: () => {
    const currYear = moment().format('YYYY')
    const arr = []
    for (let i = 1; i <= 1e2; i++) {
      const year = Number(currYear) + 1 - i
      const yearStr = `${year} / ${year + 543}`
      arr.push({ key: i, value: year, text: yearStr })
    }
    return arr
  },
  MENU: (hidden, isAdmin, role, status, cuscode, role_web_admin, notiList) => {
    // key 80
    let menuList = [
      {
        key: 1,
        text: (
          <>
            <HomeOutlined /> หน้าแรก
          </>
        ),
        onClick: () => redirect(ROUTE_PATH.HOMEPAGE.LINK),
      },
      {
        key: 2,
        text: (
          <>
            <FcAutomotive /> เช็คเบี้ยออโต้
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.VEHICLE_SELECTION.LINK}`),
        hidden:
          (isAdmin === 1 && role_web_admin.includes('account-vif')) ||
          ['admin-sqc', 'admin-sqc2'].includes(role_web_admin) ||
          (isAdmin === 1 && role === 7),
      },
      // { key: 3, text: 'เช็คเบี้ยโอนโค้ด' },
      // {
      // 	key: 4,
      // 	text: (
      // 		<>
      // 			<CalculatorOutlined /> คำนวณภาษีรถ
      // 		</>
      // 	),
      // },
      {
        key: 5,
        text: (
          <>
            <HiOutlineDocumentReport /> ประวัติการพิมพ์กรมธรรม์
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/insurance-history`),
        // hidden:
        //   (isAdmin === 1 && role_web_admin.includes('account-vif')) ||
        //   ['admin-sqc', 'admin-sqc2'].includes(role_web_admin) ||
        //   (isAdmin === 1 && role === 7),
      },
      {
        key: 6,
        text: (
          <>
            <FaFileInvoiceDollar /> ใบแจ้งหนี้ / ใบวางบิล
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/invoice`),
        disabled: hidden === '1' || status === 'notview',
        hidden:
          hidden === '1' ||
          status === 'notview' ||
          (isAdmin === 1 && role_web_admin.includes('account-vif')) ||
          ['admin-sqc', 'admin-sqc2'].includes(role_web_admin) ||
          (isAdmin === 1 && role === 7),
      },
      {
        key: 7,
        text: (
          <>
            <WalletOutlined /> เติมเครดิต
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.DEBIT.LINK}/plusmoney`),
        disabled: hidden !== '1' || status === 'notview' || role === 4,
        hidden: hidden !== '1' || status === 'notview' || role === 4,
      },
      {
        key: 43,
        text: (
          <>
            <WalletOutlined /> แนบสลิปรายการบิล
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.UPLOADSLIPBILL.LINK}`),
        disabled: role !== 4,
        hidden: role !== 4,
      },
      {
        key: 61,
        text: (
          <>
            <WalletOutlined /> ติดตามสถานะต่อภาษี
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.STATUS.LINK}`),
        hidden:
          (isAdmin === 1 && role_web_admin.includes('account-vif')) ||
          ['admin-sqc', 'admin-sqc2'].includes(role_web_admin) ||
          (isAdmin === 1 && role === 7),
      },
      {
        key: 67,
        text: (
          <>
            <GiPerspectiveDiceSixFacesRandom /> วงล้อลุ้นโชค
          </>
        ),
        onClick: () => redirect(`${ROUTE_PATH.WINWHEEL.LINK}`),
        hidden:
          (isAdmin === 1 && role_web_admin.includes('account-vif')) ||
          ['admin-sqc', 'admin-sqc2'].includes(role_web_admin) ||
          (isAdmin === 1 && role === 7),
      },
      // {
      // 	key: 52,
      // 	text: (
      // 		<>
      // 			<FundViewOutlined /> ติดตามค่างวด
      // 		</>
      // 	),
      // 	onClick: () =>
      // 		redirect(`${ROUTE_PATH.REPORT.LINK}/follow-install-insure`),
      // 	disabled: status === 'notview',
      // 	hidden:
      // 		status === 'notview' || (isAdmin === 1 && [3, 5].includes(role)),
      // },
      // {
      // 	key: 37,
      // 	text: (
      // 		<>
      // 			<TrophyOutlined /> ตารางค่าคอมมิชชั่น
      // 		</>
      // 	),
      // 	onClick: () => redirect(`${ROUTE_PATH.COMMISSION_TABLE.LINK}`),
      // 	disabled: status === 'notview' ? true : false,
      // 	hidden: status === 'notview' ? true : false,
      // },
      {
        key: 8,
        text: (
          <>
            <HiOutlineDocumentReport /> รายงาน
          </>
        ),
        hidden:
          ['admin-sqc', 'admin-sqc2', 'account-vif3'].includes(
            role_web_admin,
          ) ||
          (isAdmin === 1 && role === 7),
        submenu: [
          {
            key: 47,
            text: 'เช็คเบี้ยคุ้มภัยลูกค้าเก่า',
            onClick: () =>
              redirect(`${ROUTE_PATH.REPORT.LINK}/insure-kumpai-renew`),
            disabled: isAdmin === 1 && role === 5,
          },
          {
            key: 76,
            text: 'ค้นหาประวัติลูกค้าเดิม',
            onClick: () =>
              redirect(`${ROUTE_PATH.REPORT.LINK}/customer-history`),
            disabled: isAdmin === 1 && role === 5,
          },
          {
            key: 45,
            text: 'รายงานเปิดบิล',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/history-bill`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          {
            key: 54,
            text: 'รายงานยกเลิกบิล',
            onClick: () =>
              redirect(`${ROUTE_PATH.REPORT.LINK}/cancel-history-bill`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          {
            key: 46,
            text: 'รายงานประจำวัน',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sale-shop`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          {
            key: 9,
            text: 'รายงานประจำวัน',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sales`),
            disabled:
              status === 'notview' || ['fin-service'].includes(role_web_admin),
          },
          {
            key: 53,
            text: 'รายงานประจำวัน',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sales-admin`),
            disabled:
              status !== 'notview' || ['fin-service'].includes(role_web_admin),
          },
          {
            key: 10,
            text: 'รายงานยกเลิกกรมธรรม์',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/cancel`),
            disabled: isAdmin === 1 && ['account-vif'].includes(role_web_admin),
          },
          {
            key: 62,
            text: 'รอรับงานต่อภาษี',
            onClick: () => redirect(`${ROUTE_PATH.WAITRENEW.LINK}`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          {
            key: 63,
            text: 'สถานะงานต่อภาษี',
            onClick: () => redirect(`${ROUTE_PATH.STATUSRENEW.LINK}/รอนำส่ง`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          {
            key: 70,
            text: 'รายงานเบิกเงิน',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/withdraw-tro`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          {
            key: 73,
            text: 'สลักหลังกรมธรรม์',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/endorse-report`),
            disabled: isAdmin === 1 && ['account-vif'].includes(role_web_admin),
            noti: notiList.endorse,
          },
          {
            key: 36,
            text: 'รายงานประจำปี',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sales_year`),
            disabled:
              status === 'notview' || ['fin-service'].includes(role_web_admin),
          },
          {
            key: 64,
            text: 'รายงานคืนเครดิต',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/return-credit`),
            disabled: hidden !== '1' || status === 'notview' || role === 4,
          },
          {
            key: 32,
            text: 'ยอดขายลูกทีม',
            onClick: () =>
              redirect(`${ROUTE_PATH.REPORT.LINK}/downline-salereport`),
            disabled:
              status === 'notview' || ['fin-service'].includes(role_web_admin),
          },
          {
            key: 59,
            text: 'รายงานใบกำกับรายวัน',
            onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/tax-daily`),
            disabled:
              status === 'notview' || !['fin-service'].includes(role_web_admin),
          },
          {
            key: 52,
            text: 'รายงานค่าคอมช๊อปตรอ.',
            onClick: () =>
              redirect(`${ROUTE_PATH.REPORT.LINK}/com-incentive-shoptro`),
            disabled:
              status === 'notview' || !['fin-service'].includes(role_web_admin),
          },
          {
            key: 72,
            text: 'ตรวจสอบแนบสลิปบิล',
            onClick: () =>
              redirect(`${ROUTE_PATH.REPORT.LINK}/finservice-checkslipbill`),
            disabled: !['fin-service'].includes(role_web_admin),
          },
          // { key: 9, text: 'รายงานค่าคอม' },
          // { key: 10, text: 'รายงานต่ออายุ' },
          // { key: 11, text: 'รายงานออกกรมแยก บ.กลาง' },
          // { key: 12, text: 'รายงานออกกรมแยก ประกัน' },
          // { key: 13, text: 'รายงานแจ้งเบิกกระดาษ' },
          // { key: 15, text: 'รายงานกรม error' },
          // { key: 16, text: 'รายงานวงเงินเครดิต' },
        ],
      },
      // {
      // 	key: 17,
      // 	text: 'ตารางค่าคอมมิชชั่น',
      // 	onClick: () => redirect(`${ROUTE_PATH.COMMISSION_TABLE.LINK}`),
      // },
      // { key: 17, text: 'ติดตามสถานะงาน' },
      // { key: 18, text: 'สถานะการผ่อน' },
      // { key: 19, text: 'เติมเงิน / ชำระยอด QR' },
      // { key: 20, text: 'ฐานข้อมูลลูกค้า' },
    ]
    if (['admin-vif'].includes(role_web_admin)) {
      menuList.push(
        {
          key: 18,
          text: 'รายงานแอดมิน',
          submenu: [
            {
              key: 19,
              text: 'รายการทั้งหมด',
              onClick: () => redirect(`${ROUTE_PATH.ALL_INSURANCE_ADMIN.LINK}`),
            },
            {
              key: 20,
              text: 'ยอดขายกรมธรรม์',
              onClick: () =>
                redirect(`${ROUTE_PATH.SYSTEM_PAY_INSURANCE.LINK}`),
            },
            {
              key: 23,
              text: 'ยกเลิกกรมธรรม์',
              onClick: () =>
                redirect(`${ROUTE_PATH.CANCEL_INSURANCE_ADMIN.LINK}`),
            },
            {
              key: 74,
              text: 'สลักหลังกรมธรรม์',
              onClick: () =>
                redirect(`${ROUTE_PATH.ENDORSE_INSURANCE_ADMIN.LINK}`),
            },
            {
              key: 21,
              text: 'ใบแจ้งหนี้',
              onClick: () => redirect(`${ROUTE_PATH.INVOICE_ADMIN.LINK}`),
            },
            {
              key: 42,
              text: 'ใบแจ้งหนี้สำหรับผ่อน',
              onClick: () => redirect(`${ROUTE_PATH.PAY_INSTALLMENT.LINK}`),
            },
            {
              key: 66,
              text: 'ตรวจสอบคืนเครดิต',
              onClick: () => redirect(`${ROUTE_PATH.CHECK_CREDIT_RETURN.LINK}`),
            },
            {
              key: 22,
              text: 'ออกกรมธรรม์',
              onClick: () => redirect(`${ROUTE_PATH.INSURANCE_QUANTITY.LINK}`),
            },
            {
              key: 33,
              text: 'Non-Active',
              onClick: () => redirect(`${ROUTE_PATH.NON_ACTIVE_ADMIN.LINK}`),
            },
            {
              key: 58,
              text: 'ยอดขายทีม',
              onClick: () => redirect(`${ROUTE_PATH.DOWNLINE_SALE.LINK}`),
            },
            {
              key: 78,
              text: 'เช็คงานออกกรมธรรม์ซ้ำ',
              onClick: () => redirect(`${ROUTE_PATH.CHECK_DUPP_POLICY.LINK}`),
            },
          ],
        },
        {
          key: 40,
          text: 'แอดมิน',
          submenu: [
            {
              key: 50,
              text: 'บริษัทประกันขึ้นระบบ',
              onClick: () => redirect(`${ROUTE_PATH.COMPANYONVIF_ADMIN.LINK}`),
            },
            {
              key: 34,
              text: 'ล็อก User',
              onClick: () => redirect(`${ROUTE_PATH.LOCKUSER_ADMIN.LINK}`),
            },
            {
              key: 49,
              text: 'ค้นหากรมธรรม์เดิม',
              onClick: () =>
                redirect(`${ROUTE_PATH.INSURANCE_OIDS_ADMIN.LINK}`),
            },
            {
              key: 51,
              text: 'ตรวจสอบ Log Api',
              onClick: () => redirect(`${ROUTE_PATH.CHECK_LOG_API.LINK}`),
            },
            {
              key: 35,
              text: 'เพิ่มผู้ใช้งานแอดมิน',
              onClick: () => redirect(`${ROUTE_PATH.CREATE_USER_ADMIN.LINK}`),
            },
            {
              key: 38,
              text: 'เปิดสิทธ์ระบบ ตรอ.',
              onClick: () =>
                redirect(`${ROUTE_PATH.CREATE_USER_BY_CUSCODE.LINK}`),
            },
            {
              key: 39,
              text: 'genQrcode',
              onClick: () => redirect(`${ROUTE_PATH.GEN_QRCODE_ADMIN.LINK}`),
            },
            {
              key: 77,
              text: 'ปลดล็อกป้องกันซ้ำ',
              onClick: () => redirect(`${ROUTE_PATH.UNLOCK_WAIT_COMPANY.LINK}`),
            },
            {
              key: 79,
              text: 'อัพโหลดไฟล์เข้าระบบ',
              onClick: () => redirect(`${ROUTE_PATH.DEDUCT_CREDIT.LINK}`),
            },
            {
              key: 80,
              text: 'ปรับสถานะเครดิต',
              onClick: () => redirect(`${ROUTE_PATH.EDIT_DETAIL_USER.LINK}`),
            },
            // {
            // 	key: 39,
            // 	text: 'Import User',
            // 	onClick: () => redirect(`${ROUTE_PATH.CREATE_USER.LINK}`),
            // },
          ],
        },
        {
          key: 24,
          text: 'รายงานบัญชี',
          submenu: [
            {
              key: 25,
              text: 'รายงานการรับชำระ',
              onClick: () =>
                redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
            },
            {
              key: 26,
              text: 'รายงานสรุปยอดค้างชำระ',
              onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
            },
            {
              key: 27,
              text: 'รายงานลูกหนี้รายตัว',
              onClick: () => redirect(`${ROUTE_PATH.RECEIVABLES.LINK}`),
            },
            {
              key: 28,
              text: 'รายงานรอบวางบิล',
              onClick: () => redirect(`${ROUTE_PATH.BILLING.LINK}`),
            },
            {
              key: 65,
              text: 'รอบวางบิลตามยอดค้าง',
              onClick: () =>
                redirect(`${ROUTE_PATH.BILLFOLLOWOSDBALANCE.LINK}`),
            },
            {
              key: 29,
              text: 'Aging',
              onClick: () => redirect(`${ROUTE_PATH.AGING.LINK}`),
            },
            {
              key: 41,
              text: 'รายงานการเติมเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTDEBIT.LINK}`),
            },
            {
              key: 57,
              text: 'รายงานชำระล่าช้า',
              onClick: () => redirect(`${ROUTE_PATH.OVERDUE.LINK}`),
            },
            {
              key: 30,
              text: 'รายการยอดขาย',
              onClick: () => redirect(`${ROUTE_PATH.SELLLIST.LINK}`),
            },
            {
              key: 31,
              text: 'รายการยกเลิกกรมธรรม์',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCANCEL.LINK}`),
            },
            {
              key: 60,
              text: 'รายการ Log Error',
              onClick: () => redirect(`${ROUTE_PATH.REPORTLOGERROR.LINK}`),
            },
            {
              key: 68,
              text: 'รายงานจับเลขงานเติมเงิน',
              onClick: () =>
                redirect(`${ROUTE_PATH.REPORTMATCHLISTDEBIT.LINK}`),
            },
          ],
        },
        {
          key: 48,
          text: 'รายงานบัญชี (ช๊อป ตรอ)',
          submenu: [
            {
              key: 46,
              text: 'รายงานประจำวัน (ช็อปตรอ)',
              onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sale-account`),
            },
            {
              key: 75,
              text: 'รายงานบิล (ช็อปตรอ)',
              onClick: () => redirect(`${ROUTE_PATH.BILLACCOUNT.LINK}`),
            },
            {
              key: 55,
              text: 'รายงานยกเลิกบิล',
              onClick: () =>
                redirect(`${ROUTE_PATH.REPORT.LINK}/cancel-bill-account`),
            },
            {
              key: 44,
              text: 'ตรวจสอบแนบสลิปบิล',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCHECKSLIPBILL.LINK}`),
            },
            {
              key: 71,
              text: 'รายงานการเบิกเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTWITHDRAW.LINK}`),
            },
          ],
        },
      )
    } else if (['admin-vif7'].includes(role_web_admin)) {
      menuList.push(
        {
          key: 18,
          text: 'รายงานแอดมิน',
          submenu: [
            {
              key: 19,
              text: 'รายการทั้งหมด',
              onClick: () => redirect(`${ROUTE_PATH.ALL_INSURANCE_ADMIN.LINK}`),
            },
            {
              key: 20,
              text: 'ยอดขายกรมธรรม์',
              onClick: () =>
                redirect(`${ROUTE_PATH.SYSTEM_PAY_INSURANCE.LINK}`),
            },
            {
              key: 22,
              text: 'ออกกรมธรรม์',
              onClick: () => redirect(`${ROUTE_PATH.INSURANCE_QUANTITY.LINK}`),
            },
            {
              key: 33,
              text: 'Non-Active',
              onClick: () => redirect(`${ROUTE_PATH.NON_ACTIVE_ADMIN.LINK}`),
            },
            {
              key: 58,
              text: 'ยอดขายทีม',
              onClick: () => redirect(`${ROUTE_PATH.DOWNLINE_SALE.LINK}`),
            },
            {
              key: 78,
              text: 'เช็คงานออกกรมธรรม์ซ้ำ',
              onClick: () => redirect(`${ROUTE_PATH.CHECK_DUPP_POLICY.LINK}`),
            },
          ],
        },
        {
          key: 40,
          text: 'แอดมิน',
          submenu: [
            {
              key: 50,
              text: 'บริษัทประกันขึ้นระบบ',
              onClick: () => redirect(`${ROUTE_PATH.COMPANYONVIF_ADMIN.LINK}`),
            },
            {
              key: 34,
              text: 'ล็อก User',
              onClick: () => redirect(`${ROUTE_PATH.LOCKUSER_ADMIN.LINK}`),
            },
            {
              key: 49,
              text: 'ค้นหากรมธรรม์เดิม',
              onClick: () =>
                redirect(`${ROUTE_PATH.INSURANCE_OIDS_ADMIN.LINK}`),
            },
            {
              key: 51,
              text: 'ตรวจสอบ Log Api',
              onClick: () => redirect(`${ROUTE_PATH.CHECK_LOG_API.LINK}`),
            },
            {
              key: 77,
              text: 'ปลดล็อกป้องกันซ้ำ',
              onClick: () => redirect(`${ROUTE_PATH.UNLOCK_WAIT_COMPANY.LINK}`),
            },
            {
              key: 79,
              text: 'อัพโหลดไฟล์เข้าระบบ',
              onClick: () => redirect(`${ROUTE_PATH.DEDUCT_CREDIT.LINK}`),
            },
            // {
            // 	key: 39,
            // 	text: 'Import User',
            // 	onClick: () => redirect(`${ROUTE_PATH.CREATE_USER.LINK}`),
            // },
          ],
        },
        {
          key: 24,
          text: 'รายงานบัญชี',
          submenu: [
            {
              key: 25,
              text: 'รายงานการรับชำระ',
              onClick: () =>
                redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
            },
            {
              key: 26,
              text: 'รายงานสรุปยอดค้างชำระ',
              onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
            },
            {
              key: 27,
              text: 'รายงานลูกหนี้รายตัว',
              onClick: () => redirect(`${ROUTE_PATH.RECEIVABLES.LINK}`),
            },
            {
              key: 28,
              text: 'รายงานรอบวางบิล',
              onClick: () => redirect(`${ROUTE_PATH.BILLING.LINK}`),
            },
            {
              key: 65,
              text: 'รอบวางบิลตามยอดค้าง',
              onClick: () =>
                redirect(`${ROUTE_PATH.BILLFOLLOWOSDBALANCE.LINK}`),
            },
            {
              key: 29,
              text: 'Aging',
              onClick: () => redirect(`${ROUTE_PATH.AGING.LINK}`),
            },
            {
              key: 41,
              text: 'รายงานการเติมเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTDEBIT.LINK}`),
            },
            {
              key: 57,
              text: 'รายงานชำระล่าช้า',
              onClick: () => redirect(`${ROUTE_PATH.OVERDUE.LINK}`),
            },
            {
              key: 30,
              text: 'รายการยอดขาย',
              onClick: () => redirect(`${ROUTE_PATH.SELLLIST.LINK}`),
            },
            {
              key: 31,
              text: 'รายการยกเลิกกรมธรรม์',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCANCEL.LINK}`),
            },
            {
              key: 60,
              text: 'รายการ Log Error',
              onClick: () => redirect(`${ROUTE_PATH.REPORTLOGERROR.LINK}`),
            },
            // {
            // 	key: 68,
            // 	text: 'รายงานจับเลขงานเติมเงิน',
            // 	onClick: () =>
            // 		redirect(`${ROUTE_PATH.REPORTMATCHLISTDEBIT.LINK}`),
            // },
          ],
        },
      )
    } else if (['account-vif'].includes(role_web_admin) && role === 3) {
      menuList.push(
        {
          key: 18,
          text: 'แอดมิน',
          submenu: [
            {
              key: 49,
              text: 'ค้นหากรมธรรม์เดิม',
              onClick: () =>
                redirect(`${ROUTE_PATH.INSURANCE_OIDS_ADMIN.LINK}`),
            },
          ],
        },
        {
          key: 24,
          text: 'รายงานบัญชี',
          submenu: [
            {
              key: 25,
              text: 'รายงานการรับชำระ',
              onClick: () =>
                redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
            },
            {
              key: 26,
              text: 'รายงานสรุปยอดค้างชำระ',
              onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
            },
            {
              key: 27,
              text: 'รายงานลูกหนี้รายตัว',
              onClick: () => redirect(`${ROUTE_PATH.RECEIVABLES.LINK}`),
            },
            {
              key: 28,
              text: 'รายงานรอบวางบิล',
              onClick: () => redirect(`${ROUTE_PATH.BILLING.LINK}`),
            },
            {
              key: 29,
              text: 'Aging',
              onClick: () => redirect(`${ROUTE_PATH.AGING.LINK}`),
            },
            {
              key: 41,
              text: 'รายงานการเติมเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTDEBIT.LINK}`),
            },
            {
              key: 57,
              text: 'รายงานชำระล่าช้า',
              onClick: () => redirect(`${ROUTE_PATH.OVERDUE.LINK}`),
            },
            {
              key: 30,
              text: 'รายการยอดขาย',
              onClick: () => redirect(`${ROUTE_PATH.SELLLIST.LINK}`),
            },
            {
              key: 31,
              text: 'รายการยกเลิกกรมธรรม์',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCANCEL.LINK}`),
            },
            {
              key: 60,
              text: 'รายการ Log Error',
              onClick: () => redirect(`${ROUTE_PATH.REPORTLOGERROR.LINK}`),
            },
            // {
            // 	key: 68,
            // 	text: 'รายงานจับเลขงานเติมเงิน',
            // 	onClick: () =>
            // 		redirect(`${ROUTE_PATH.REPORTMATCHLISTDEBIT.LINK}`),
            // },
          ],
        },
      )
    } else if (['account-vif2'].includes(role_web_admin) && role === 3) {
      menuList.push(
        {
          key: 18,
          text: 'แอดมิน',
          submenu: [
            {
              key: 20,
              text: 'ใบแจ้งหนี้',
              onClick: () => redirect(`${ROUTE_PATH.INVOICE_ADMIN.LINK}`),
            },
            {
              key: 42,
              text: 'ใบแจ้งหนี้สำหรับผ่อน',
              onClick: () => redirect(`${ROUTE_PATH.PAY_INSTALLMENT.LINK}`),
            },
            {
              key: 66,
              text: 'ตรวจสอบคืนเครดิต',
              onClick: () => redirect(`${ROUTE_PATH.CHECK_CREDIT_RETURN.LINK}`),
            },
            {
              key: 33,
              text: 'ล็อก User',
              onClick: () => redirect(`${ROUTE_PATH.LOCKUSER_ADMIN.LINK}`),
            },
            {
              key: 49,
              text: 'ค้นหากรมธรรม์เดิม',
              onClick: () =>
                redirect(`${ROUTE_PATH.INSURANCE_OIDS_ADMIN.LINK}`),
            },
            {
              key: 80,
              text: 'ปรับสถานะเครดิต',
              onClick: () => redirect(`${ROUTE_PATH.EDIT_DETAIL_USER.LINK}`),
            },
          ],
        },
        {
          key: 24,
          text: 'รายงานบัญชี',
          submenu: [
            {
              key: 25,
              text: 'รายงานการรับชำระ',
              onClick: () =>
                redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
            },
            {
              key: 26,
              text: 'รายงานสรุปยอดค้างชำระ',
              onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
            },
            {
              key: 27,
              text: 'รายงานลูกหนี้รายตัว',
              onClick: () => redirect(`${ROUTE_PATH.RECEIVABLES.LINK}`),
            },
            {
              key: 28,
              text: 'รายงานรอบวางบิล',
              onClick: () => redirect(`${ROUTE_PATH.BILLING.LINK}`),
            },
            {
              key: 29,
              text: 'Aging',
              onClick: () => redirect(`${ROUTE_PATH.AGING.LINK}`),
            },
            {
              key: 41,
              text: 'รายงานการเติมเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTDEBIT.LINK}`),
            },
            {
              key: 57,
              text: 'รายงานชำระล่าช้า',
              onClick: () => redirect(`${ROUTE_PATH.OVERDUE.LINK}`),
            },
            {
              key: 30,
              text: 'รายการยอดขาย',
              onClick: () => redirect(`${ROUTE_PATH.SELLLIST.LINK}`),
            },
            {
              key: 31,
              text: 'รายการยกเลิกกรมธรรม์',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCANCEL.LINK}`),
            },
            {
              key: 60,
              text: 'รายการ Log Error',
              onClick: () => redirect(`${ROUTE_PATH.REPORTLOGERROR.LINK}`),
            },
            {
              key: 68,
              text: 'รายงานจับเลขงานเติมเงิน',
              onClick: () =>
                redirect(`${ROUTE_PATH.REPORTMATCHLISTDEBIT.LINK}`),
            },
          ],
        },
        {
          key: 48,
          text: 'รายงานบัญชี (ช็อปตรอ)',
          submenu: [
            {
              key: 46,
              text: 'รายงานประจำวัน (ช็อปตรอ)',
              onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sale-account`),
            },
            {
              key: 55,
              text: 'รายงานยกเลิกบิล',
              onClick: () =>
                redirect(`${ROUTE_PATH.REPORT.LINK}/cancel-bill-account`),
            },
            {
              key: 44,
              text: 'ตรวจสอบแนบสลิปบิล',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCHECKSLIPBILL.LINK}`),
            },
            {
              key: 71,
              text: 'รายงานการเบิกเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTWITHDRAW.LINK}`),
            },
            {
              key: 59,
              text: 'รายงานใบกำกับรายวัน',
              onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/tax-daily`),
            },
          ],
        },
      )
    } else if (['account-vif'].includes(role_web_admin) && role === 5) {
      menuList.push(
        {
          key: 18,
          text: 'แอดมิน',
          submenu: [
            {
              key: 20,
              text: 'ใบแจ้งหนี้',
              onClick: () => redirect(`${ROUTE_PATH.INVOICE_ADMIN.LINK}`),
            },
            {
              key: 49,
              text: 'ค้นหากรมธรรม์เดิม',
              onClick: () =>
                redirect(`${ROUTE_PATH.INSURANCE_OIDS_ADMIN.LINK}`),
            },
          ],
        },
        {
          key: 24,
          text: 'รายงานบัญชี',
          submenu: [
            {
              key: 25,
              text: 'รายงานการรับชำระ',
              onClick: () =>
                redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
            },
            {
              key: 26,
              text: 'รายงานสรุปยอดค้างชำระ',
              onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
            },
          ],
        },
        {
          key: 48,
          text: 'รายงานบัญชี (ช็อปตรอ)',
          submenu: [
            {
              key: 46,
              text: 'รายงานประจำวัน (ช็อปตรอ)',
              onClick: () => redirect(`${ROUTE_PATH.REPORT.LINK}/sale-account`),
            },
            {
              key: 55,
              text: 'รายงานยกเลิกบิล',
              onClick: () =>
                redirect(`${ROUTE_PATH.REPORT.LINK}/cancel-bill-account`),
            },
            {
              key: 44,
              text: 'ตรวจสอบแนบสลิปบิล',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCHECKSLIPBILL.LINK}`),
            },
            {
              key: 71,
              text: 'รายงานการเบิกเงิน',
              onClick: () => redirect(`${ROUTE_PATH.REPORTWITHDRAW.LINK}`),
            },
          ],
        },
      )
    } else if (['account-vif3'].includes(role_web_admin)) {
      menuList.push({
        key: 24,
        text: 'รายงานบัญชี',
        submenu: [
          {
            key: 25,
            text: 'รายงานการรับชำระ',
            onClick: () => redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
          },
          {
            key: 26,
            text: 'รายงานสรุปยอดค้างชำระ',
            onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
          },
          {
            key: 27,
            text: 'รายงานลูกหนี้รายตัว',
            onClick: () => redirect(`${ROUTE_PATH.RECEIVABLES.LINK}`),
          },
          {
            key: 28,
            text: 'รายงานรอบวางบิล',
            onClick: () => redirect(`${ROUTE_PATH.BILLING.LINK}`),
          },
          {
            key: 29,
            text: 'Aging',
            onClick: () => redirect(`${ROUTE_PATH.AGING.LINK}`),
          },
          {
            key: 57,
            text: 'รายงานชำระล่าช้า',
            onClick: () => redirect(`${ROUTE_PATH.OVERDUE.LINK}`),
          },
        ],
      })
    } else if (role === 6) {
      menuList.push({
        key: 18,
        text: 'รายงานแอดมิน',
        submenu: [
          {
            key: 58,
            text: 'ยอดขายทีม',
            onClick: () => redirect(`${ROUTE_PATH.DOWNLINE_SALE.LINK}`),
          },
        ],
      })
    } else if (['admin-sqc'].includes(role_web_admin) && role === 3) {
      menuList.push({
        key: 24,
        text: 'รายงานบัญชี',
        submenu: [
          {
            key: 25,
            text: 'รายงานการรับชำระ',
            onClick: () => redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
          },
          {
            key: 26,
            text: 'รายงานสรุปยอดค้างชำระ',
            onClick: () => redirect(`${ROUTE_PATH.OUTSTANDING_BALANCE.LINK}`),
          },
          {
            key: 27,
            text: 'รายงานลูกหนี้รายตัว',
            onClick: () => redirect(`${ROUTE_PATH.RECEIVABLES.LINK}`),
          },
          {
            key: 28,
            text: 'รายงานรอบวางบิล',
            onClick: () => redirect(`${ROUTE_PATH.BILLING.LINK}`),
          },
          {
            key: 65,
            text: 'รอบวางบิลตามยอดค้าง',
            onClick: () => redirect(`${ROUTE_PATH.BILLFOLLOWOSDBALANCE.LINK}`),
          },
          {
            key: 29,
            text: 'Aging',
            onClick: () => redirect(`${ROUTE_PATH.AGING.LINK}`),
          },
          {
            key: 41,
            text: 'รายงานการเติมเงิน',
            onClick: () => redirect(`${ROUTE_PATH.REPORTDEBIT.LINK}`),
          },
          {
            key: 57,
            text: 'รายงานชำระล่าช้า',
            onClick: () => redirect(`${ROUTE_PATH.OVERDUE.LINK}`),
          },
          {
            key: 30,
            text: 'รายการยอดขาย',
            onClick: () => redirect(`${ROUTE_PATH.SELLLIST.LINK}`),
          },
          {
            key: 31,
            text: 'รายการยกเลิกกรมธรรม์',
            onClick: () => redirect(`${ROUTE_PATH.REPORTCANCEL.LINK}`),
          },
        ],
      })
    } else if (['admin-sqc2'].includes(role_web_admin) && role === 3) {
      menuList.push(
        {
          key: 24,
          text: 'รายงานบัญชี',
          submenu: [
            {
              key: 25,
              text: 'รายงานการรับชำระ',
              onClick: () =>
                redirect(`${ROUTE_PATH.PAYMENT_ACCOUNTREPORT.LINK}`),
            },
          ],
        },
        {
          key: 48,
          text: 'รายงานบัญชี (ช็อปตรอ)',
          submenu: [
            {
              key: 44,
              text: 'ตรวจสอบแนบสลิปบิล',
              onClick: () => redirect(`${ROUTE_PATH.REPORTCHECKSLIPBILL.LINK}`),
            },
          ],
        },
      )
    }
    return menuList
  },
  SEAT: [
    {
      value: '1',
      text: '1',
    },
    {
      value: '2',
      text: '2',
    },
    {
      value: '3',
      text: '3',
    },
    {
      value: '5',
      text: '5',
    },
    {
      value: '7',
      text: '7',
    },
    {
      value: '11',
      text: '11',
    },
    {
      value: '12',
      text: '12',
    },
    {
      value: '13',
      text: '13',
    },
    {
      value: '15',
      text: '15',
    },
  ],
  // SEAT: [
  // 	{
  // 		value: '1',
  // 		text: '1',
  // 	},
  // 	{
  // 		value: '2',
  // 		text: '2',
  // 	},
  // 	{
  // 		value: '3',
  // 		text: '3',
  // 	},
  // 	{
  // 		value: '4',
  // 		text: '4',
  // 	},
  // 	{
  // 		value: '5',
  // 		text: '5',
  // 	},
  // 	{
  // 		value: '6',
  // 		text: '6',
  // 	},
  // 	{
  // 		value: '7',
  // 		text: '7',
  // 	},
  // 	{
  // 		value: '8',
  // 		text: '8',
  // 	},
  // 	{
  // 		value: '9',
  // 		text: '9',
  // 	},
  // 	{
  // 		value: '10',
  // 		text: '10',
  // 	},
  // 	{
  // 		value: '11',
  // 		text: '11',
  // 	},
  // 	{
  // 		value: '12',
  // 		text: '12',
  // 	},
  // 	{
  // 		value: '13',
  // 		text: '13',
  // 	},
  // 	{
  // 		value: '14',
  // 		text: '14',
  // 	},
  // 	{
  // 		value: '15',
  // 		text: '15',
  // 	},
  // 	{
  // 		value: '16',
  // 		text: '16',
  // 	},
  // 	{
  // 		value: '17',
  // 		text: '17',
  // 	},
  // 	{
  // 		value: '18',
  // 		text: '18',
  // 	},
  // 	{
  // 		value: '19',
  // 		text: '19',
  // 	},
  // 	{
  // 		value: '20',
  // 		text: '20',
  // 	},
  // 	{
  // 		value: '21',
  // 		text: '21',
  // 	},
  // 	{
  // 		value: '22',
  // 		text: '22',
  // 	},
  // 	{
  // 		value: '23',
  // 		text: '23',
  // 	},
  // 	{
  // 		value: '24',
  // 		text: '24',
  // 	},
  // 	{
  // 		value: '25',
  // 		text: '25',
  // 	},
  // 	{
  // 		value: '26',
  // 		text: '26',
  // 	},
  // 	{
  // 		value: '27',
  // 		text: '27',
  // 	},
  // 	{
  // 		value: '28',
  // 		text: '28',
  // 	},
  // 	{
  // 		value: '29',
  // 		text: '29',
  // 	},
  // 	{
  // 		value: '30',
  // 		text: '30',
  // 	},
  // 	{
  // 		value: '31',
  // 		text: '31',
  // 	},
  // 	{
  // 		value: '32',
  // 		text: '32',
  // 	},
  // 	{
  // 		value: '33',
  // 		text: '33',
  // 	},
  // 	{
  // 		value: '34',
  // 		text: '34',
  // 	},
  // 	{
  // 		value: '35',
  // 		text: '35',
  // 	},
  // 	{
  // 		value: '36',
  // 		text: '36',
  // 	},
  // 	{
  // 		value: '37',
  // 		text: '37',
  // 	},
  // 	{
  // 		value: '38',
  // 		text: '38',
  // 	},
  // 	{
  // 		value: '39',
  // 		text: '39',
  // 	},
  // 	{
  // 		value: '40',
  // 		text: '40',
  // 	},
  // 	{
  // 		value: '41',
  // 		text: '41',
  // 	},
  // 	{
  // 		value: '42',
  // 		text: '42',
  // 	},
  // 	{
  // 		value: '43',
  // 		text: '43',
  // 	},
  // 	{
  // 		value: '44',
  // 		text: '44',
  // 	},
  // 	{
  // 		value: '45',
  // 		text: '45',
  // 	},
  // 	{
  // 		value: '46',
  // 		text: '46',
  // 	},
  // 	{
  // 		value: '47',
  // 		text: '47',
  // 	},
  // 	{
  // 		value: '48',
  // 		text: '48',
  // 	},
  // 	{
  // 		value: '49',
  // 		text: '49',
  // 	},
  // 	{
  // 		value: '50',
  // 		text: '50',
  // 	},
  // 	{
  // 		value: 'อื่นๆ',
  // 		text: 'อื่นๆ',
  // 	},
  // ],
  BODY_TYPE: [
    {
      value: 'เก๋ง',
      text: 'เก๋ง',
    },
    {
      value: 'กระบะ',
      text: 'กระบะ',
    },
    // {
    // 	value: 'เชิงพาณิชย์',
    // 	text: 'เชิงพาณิชย์',
    // },
    // {
    // 	value: 'โดยสาร',
    // 	text: 'โดยสาร',
    // },
    // {
    // 	value: 'รับจ้าง',
    // 	text: 'รับจ้าง',
    // },
    {
      value: 'มอเตอร์ไซค์',
      text: 'มอเตอร์ไซค์',
    },
    {
      value: 'รถบรรทุก',
      text: 'รถบรรทุก',
    },
    {
      value: 'รถตู้',
      text: 'รถตู้',
    },
  ],
  FORM_TYPE: [
    {
      name: 'manual',
      value: 'คีย์มือ',
    },
    {
      name: 'auto',
      value: 'ออโต้',
    },
  ],
  YES_NO: [
    {
      value: 'yes',
      text: 'ใช่',
    },
    {
      value: 'no',
      text: 'ไม่ใช่',
    },
  ],
  LEGAL: [
    { value: 'นิติบุคคล', text: 'นิติบุคคล' },
    { value: 'บุคคลทั่วไป', text: 'บุคคลทั่วไป' },
  ],
  CompanyPrb: [
    {
      key: 0,
      value: 'เคดับบลิวไอประกันภัย',
      text: 'เคดับบลิวไอประกันภัย',
    },
    {
      key: 1,
      value: 'ฟอลคอนประกันภัย',
      text: 'ฟอลคอนประกันภัย',
    },
    {
      key: 2,
      value: 'เออร์โกประกันภัย',
      text: 'เออร์โกประกันภัย',
    },
    // {
    // 	key: 2,
    // 	value: 'ไทยศรีประกันภัย',
    // 	text: 'ไทยศรีประกันภัย',
    // },
    {
      key: 3,
      value: 'อินทรประกันภัย(สาขาสีลม)',
      text: 'อินทรประกันภัย(สาขาสีลม)',
    },
    {
      key: 4,
      value: 'คุ้มภัยโตเกียวมารีนประกันภัย',
      text: 'คุ้มภัยโตเกียวมารีนประกันภัย',
    },
    {
      key: 5,
      value: 'เจมาร์ทประกันภัย (เจพี)',
      text: 'เจมาร์ทประกันภัย (เจพี)',
    },
    {
      key: 6,
      value: 'ไทยเศรษฐกิจประกันภัย',
      text: 'ไทยเศรษฐกิจประกันภัย',
    },
    {
      key: 7,
      value: 'แอกซ่าประกันภัย',
      text: 'แอกซ่าประกันภัย',
    },
    {
      key: 8,
      value: 'วิริยะประกันภัย',
      text: 'วิริยะประกันภัย',
    },
    {
      key: 9,
      value: 'เมืองไทยประกันภัย',
      text: 'เมืองไทยประกันภัย',
    },
    {
      key: 10,
      value: 'ทิพยประกันภัย',
      text: 'ทิพยประกันภัย',
    },
    {
      key: 11,
      value: 'ชับบ์สามัคคีประกันภัย',
      text: 'ชับบ์สามัคคีประกันภัย',
    },
    {
      key: 12,
      value: 'อินทรประกันภัย',
      text: 'อินทรประกันภัย',
    },
    {
      key: 13,
      value: 'บริษัทกลาง',
      text: 'บริษัทกลาง',
    },
    {
      key: 14,
      value: 'เทเวศประกันภัย',
      text: 'เทเวศประกันภัย',
    },
  ],
  CompanyIns: [
    {
      key: 0,
      value: 'อินทรประกันภัย',
      text: 'อินทรประกันภัย',
    },
    {
      key: 1,
      value: 'คุ้มภัยโตเกียวมารีนประกันภัย',
      text: 'คุ้มภัยโตเกียวมารีนประกันภัย',
    },
    {
      key: 2,
      value: 'ชับบ์สามัคคีประกันภัย',
      text: 'ชับบ์สามัคคีประกันภัย',
    },
    {
      key: 3,
      value: 'เคดับบลิวไอประกันภัย',
      text: 'เคดับบลิวไอประกันภัย',
    },
    {
      key: 4,
      value: 'วิริยะประกันภัย',
      text: 'วิริยะประกันภัย',
    },
    {
      key: 5,
      value: 'เมืองไทยประกันภัย',
      text: 'เมืองไทยประกันภัย',
    },
    {
      key: 6,
      value: 'แอกซ่าประกันภัย',
      text: 'แอกซ่าประกันภัย',
    },
    {
      key: 7,
      value: 'ฟอลคอนประกันภัย',
      text: 'ฟอลคอนประกันภัย',
    },
    {
      key: 8,
      value: 'ไทยไพบูลย์ประกันภัย',
      text: 'ไทยไพบูลย์ประกันภัย',
    },
  ],
  brandIcons: (addition) => {
    if (addition === 'motorcycle') {
      return {
        AJEV: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-40f7577c-f5c1-42b4-af30-9a2b391426f9',
        Aprilia:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-878a1b72-60fb-4fb2-a1b4-bfb6e7ea3eb2',
        Benelli:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-fb85f329-ed2f-41e9-9f0f-d0cd4499627f',
        Bigbull:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-678a7ebb-2cf5-4386-8f49-652d57c77599',
        BMW: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-0ba5456b-a556-4b26-814b-89cc2ac8221f',
        Cfmoto:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-100d6b6f-8b68-4637-8135-ba661119dc60',
        DECO: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-f935fad5-6864-4dde-a3f2-069f20709f71',
        Ducati:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-6a76b3b2-cfb6-4fb6-a27d-1489c18e7721',
        Enfield:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-92f602a9-41ee-4a76-b97d-8eb1317a3da6',
        ETRAN:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-0aa034ff-4f3c-47f7-94ff-57f123487e6f',
        GPX: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-8ea466e3-e77b-4702-aabd-6b116728691d',
        'Harley-davidson':
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-b0418cb2-e7d0-481e-ad6c-08838a19159b',
        Honda:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-1634785b-1791-408b-aaec-2fbd53d5eabd',
        HSEM: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-63f21915-de2f-48d5-aef0-0410aba32120',
        Husqvarna:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-cd1486ae-e45c-474c-b745-7186537cd0d2',
        Indian:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-f9bb4204-53c3-43d1-8456-2e7703f3c179',
        JRD: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-829f968a-a44c-4740-ad08-9638de0e5aff',
        Kawasaki:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-c073f7a9-ca6a-4993-a211-8e630526cb46',
        Keeway:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-9700cf0e-7f9a-4c9e-a6d2-fb4729a7e235',
        Ktm: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-e00dedff-12bd-45c8-9e91-e57118bb258b',
        Lambretta:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-dbf6c841-02a6-4c91-a8d8-de568c0e4713',
        LML: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-37e7f4be-1c56-4fcf-947b-55c4d08ec1b0',
        'Moto Guzzi':
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-3d8bb428-9caa-4f17-b4e2-9f221da311cb',
        'Mv Agusta':
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-91ee7f2e-aff0-4746-8493-b817a6b4ae8e',
        NIU: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-c3c46321-3f7e-47e4-aac2-822c0cdde833',
        NKT: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-966cf39a-b199-4240-915a-a2b85d834971',
        Peugeot:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-575f36ad-5539-4fab-be7a-6bf5e3364460',
        Piaggio:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-1cd474f7-ec4c-4df8-84f0-bee238b49061',
        Platinum:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-3d8542b9-6dd6-4f3a-a47e-11501e48dd08',
        Ryuka:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-f4e6f1d6-fdc4-4f62-b3cf-39b747b41fc5',
        Scomadi:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-89e8b983-a546-493d-9c0a-5a0a54c6553a',
        SLEEK:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-5294d2bc-de51-4d0b-bed4-e9aaef7334d4',
        Stallions:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-a5102085-bd3e-4704-bd38-b18897f01634',
        STROM:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-abde5cc4-f87a-4cd4-b02c-527594d190c3',
        Suzuki:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-73585687-d906-4e86-b89c-6a8080aaf544',
        Sym: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-57c630ca-9546-499a-a825-5274fc247c25',
        Triumph:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-4fa2acb1-e8fc-4210-ab71-34007e5195dc',
        Vespa:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-0a2d151e-58dd-41ac-af7d-29f7f2e0436b',
        Yamaha:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-b90c2e85-b875-4cd9-b022-0ba7f4662dd9',
      }
    } else if (addition === 'ev') {
      return {
        VIAUTO:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-80e9491e-f261-414d-9aaa-5eab03b7489e',
        AION: 'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-f55770f6-ba01-4086-b5dd-e392b714bf75',
        CHANGAN:
          'https://finbrokerfile.sgp1.digitaloceanspaces.com/fileagent/news-banner-news/B2B/news-1231f284-0fec-4b2d-8fbc-f26a1ee1d696',
      }
    }
  },
  Error_Message_Api: [
    '(kumpai api error) ContactAdmin, ContactAdmin:(SendReqP3/TimeOut) please contact Technical Support Safety Insurance PCL.',
    'This agentcode has no stock left',
    'Authentication fail.',
    'Authentication fail: User Name/ Password is incorrect.',
    'Test Error',
  ],
  YEAR_OF_TAX_LACK: () => {
    const date = new Date()

    let year = moment(date).format('YYYY')
    let beforeYear = parseInt(year) - 5
    let yearArr = []
    let i = 0

    while (beforeYear < year) {
      let beYear = beforeYear + 543
      yearArr.push({
        key: i,
        value: beforeYear,
        text: `${beforeYear} / ${beYear}`,
      })
      beforeYear = beforeYear + 1
      i = i + 1
    }
    return yearArr
  },
  DAMAGE1: () => {
    let price = 0
    let priceArr = []
    let i = 0
    while (price <= 10000) {
      priceArr.push({ key: i, value: price, text: numberWithCommas(price) })
      price = price + 1000
      i = i + 1
    }
    return priceArr
  },
  DAMAGE2: () => {
    let price = 0
    let priceArr = []
    let i = 0
    while (price <= 20000000) {
      priceArr.push({ key: i, value: price, text: numberWithCommas(price) })
      price = price + 5000000
      i = i + 1
    }
    return priceArr
  },
  DAMAGE3: () => {
    let price = 0
    let priceArr = []
    let i = 0
    while (price <= 2000000) {
      priceArr.push({ key: i, value: price, text: numberWithCommas(price) })
      price = price + 100000
      i = i + 1
    }
    return priceArr
  },
  DAMAGE4: () => {
    let price = 0
    let priceArr = []
    let i = 0
    while (price <= 1000000) {
      priceArr.push({ key: i, value: price, text: numberWithCommas(price) })
      price = price + 50000
      i = i + 1
    }
    return priceArr
  },
  DAMAGE5: () => {
    let price = 0
    let priceArr = []
    let i = 0
    while (price <= 1000000) {
      priceArr.push({ key: i, value: price, text: numberWithCommas(price) })
      price = price + 100000
      i = i + 1
    }
    return priceArr
  },
  TITLE: async (type) => {
    const API = defaultController()
    const res = await API.getTitle()
    if (isValidResponse(res)) {
      const text = res.result
      const textFilter = text.filter((e) => e.type === type)
      const textOption = textFilter.map((e) => {
        return {
          value: e.title,
          text: e.title,
        }
      })
      return textOption
    }
  },
  titleViriya: async (type) => {
    const API = titlesController()
    const res = await API.getTitleViriya()
    if (isValidResponse(res)) {
      const text = res.result
      const textFilter = text.filter((e) => e.type_legal === type)
      const textOption = textFilter.map((e) => {
        return {
          value: e.prename_desc,
          text: e.prename_desc,
        }
      })
      return textOption
    }
  },
  titleIntraTH: async (type) => {
    const API = titlesController()
    const res = await API.getTitleIntra()
    if (isValidResponse(res)) {
      const text = res.result
      const textFilter = text.filter((e) => e.type_legal === type)
      const textOption = textFilter.map((e) => {
        return {
          value: e.title_th,
          text: e.title_th,
        }
      })
      return textOption
    }
  },
  titleIntraEN: async (type) => {
    const API = titlesController()
    const res = await API.getTitleIntra()
    if (isValidResponse(res)) {
      const text = res.result
      const textFilter = text.filter((e) => e.type_legal === type)
      const textOption = textFilter.map((e) => {
        return {
          value: e.title_eng,
          text: e.title_eng,
        }
      })
      return textOption
    }
  },
  titleDvsTH: async (type) => {
    const API = titlesController()
    const res = await API.getTitleDvs()
    if (isValidResponse(res)) {
      const text = res.result
      const textFilter = text.filter((e) => e.type_legal === type)
      const textOption = textFilter.map((e) => {
        return {
          value: e.titlelong,
          text: e.titlelong,
        }
      })
      return textOption
    }
  },
  CAR_TYPE: async () => {
    const API = carController()
    const res = await API.getCarType()
    if (isValidResponse(res)) {
      const carType = res.result
      const carTypeOption = carType.map((e) => {
        return {
          value: e.car_type,
          text: `${e.car_type} ${e.car_type_description}`,
        }
      })
      return carTypeOption
    }
  },
  CAR_TYPE_PRB: async () => {
    const API = defaultController()
    const res = await API.getCarTypePrb()
    if (isValidResponse(res)) {
      const compulsoryTypeRes = res.result
      const compulsoryTypeOption = compulsoryTypeRes.map((e) => {
        return {
          ...e,
          value: e.prb_type_code,
          text: `(${e.prb_type_code}) ${e.prb_type_description}`,
        }
      })
      return compulsoryTypeOption.sort((a, b) => a.value - b.value)
    }
  },
  COMPANY_PRB_BRAND: async () => {
    const API = companyController()
    const res = await API.getCompanyBrand()
    if (isValidResponse(res)) {
      const company = res.result
      const companyList = company.filter((e) => e.prb_rank !== '99')
      const companyOption = companyList.map((e) => {
        return {
          ...e,
          value: e.company_name,
          text: `${e.company_name} (ออกหน้าร้าน)`,
        }
      })
      return companyOption.sort((a, b) => a.prb_rank - b.prb_rank)
    }
  },
  COMPANY_PRB_BLOCK_BRAND: async () => {
    const API = companyController()
    const res = await API.getBlockCompany()
    if (isValidResponse(res)) {
      const company = res?.result?.block_company
      return company
    } else {
      return null
    }
  },
  COMPANY_INSURE_BRAND: async () => {
    const API = companyController()
    const res = await API.getCompanyBrand()
    if (isValidResponse(res)) {
      const company = res.result
      const companyList = company.filter(
        (e) => e.insure_rank?.substr(1, 2) === 's',
      )
      const companyOption = companyList.map((e) => {
        return {
          ...e,
          value: e.company_name,
          text: `${e.company_name} (ออกหน้าร้าน)`,
        }
      })
      return companyOption.sort(
        (a, b) => a.insure_rank?.split('s')[0] - b.insure_rank.split('s')[0],
      )
    }
  },
  CAR_BRAND: async () => {
    const API = carController()
    const res = await API.getAllBrands()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          rank: e.rank,
          value: e.brand,
          text: e.brand,
          image: e.icon,
        }
      })
      brandOption.push({
        rank: null,
        value: 'none',
        text: 'เพิ่มยี่ห้อรถ',
        image: null,
      })
      return brandOption
    }
  },
  CAR_YEAR: async (brand) => {
    const API = carController()
    const res = await API.getYearsByName(brand)
    if (isValidResponse(res)) {
      const years = res.result
      const yearOption = years.map((e) => {
        return {
          value: e.year,
          text: e.year,
        }
      })
      yearOption.push({
        value: 'none',
        text: 'เพิ่มปีรถ',
      })
      return yearOption
    } else {
      return [
        {
          value: 'none',
          text: 'เพิ่มปีรถ',
        },
      ]
    }
  },
  CAR_YEAR_ALL: () => {
    const currYear = moment().format('YYYY')
    const arr = []
    for (let i = 1; i <= 1e2; i++) {
      const year = Number(currYear) + 1 - i
      const yearStr = `${year}`
      arr.push({ key: i, value: year, text: yearStr })
    }
    return arr
  },
  CAR_SERIES: async (brand, year) => {
    const API = carController()
    const res = await API.getSeriesByName(brand, year)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.series,
          text: e.series,
        }
      })
      seriesOption.push({
        value: 'none',
        text: 'เพิ่มรุ่นรถ',
      })
      return seriesOption
    } else {
      return [
        {
          value: 'none',
          text: 'เพิ่มรุ่นรถ',
        },
      ]
    }
  },
  CAR_SUB_SERIES: async (brand, year, series) => {
    const API = carController()
    const res = await API.getSubseriesByName(brand, year, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.sub_series,
          text: e.sub_series === '' ? 'ไม่มี' : e.sub_series,
        }
      })
      return subSeriesOption
    } else {
      return []
    }
  },
  CAR_BRAND_AXA_CMI: async () => {
    const API = carController()
    const res = await API.getBrandAxaCmi()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.Make,
          text: e.Make,
        }
      })
      return brandsOption
    }
  },
  CAR_SERIES_AXA_CMI: async (brand) => {
    const API = carController()
    const res = await API.getSeriesAxaCmi(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.Model,
          text: e.Model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_AXA_CMI: async (brand, series) => {
    const API = carController()
    const res = await API.getSubseriesAxaCmi(brand, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.SubModel,
          text: e.SubModel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_AXA_INS: async () => {
    const API = carController()
    const res = await API.getBrandAxaIns()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.Make,
          text: e.Make,
        }
      })
      return brandsOption
    }
  },
  CAR_YEAR_AXA_INS: async (brand) => {
    const API = carController()
    const res = await API.getYearAxaIns(brand)
    if (isValidResponse(res)) {
      const years = res.result
      const yearOption = years.map((e) => {
        return {
          value: e.year,
          text: e.year,
        }
      })
      return yearOption
    }
  },
  CAR_SERIES_AXA_INS: async (brand, year) => {
    const API = carController()
    const res = await API.getSeriesAxaIns(brand, year)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.Model,
          text: e.Model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_AXA_INS: async (brand, year, series) => {
    const API = carController()
    const res = await API.getSubseriesAxaIns(brand, year, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.SubModel,
          text: e.SubModel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_INTRA: async () => {
    const API = carController()
    const res = await API.getBrandIntra()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          no: e.no,
          value: e.brand_short,
          text: e.brand,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_INTRA: async (brand) => {
    const API = carController()
    const res = await API.getSeriesIntraByName(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.id,
          text: e.description,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_INTRA_V2: async () => {
    const API = carController()
    const res = await API.getBrandIntraV2()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_code,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_INTRA_V2: async (brand) => {
    const API = carController()
    const res = await API.getSeriesIntraByNameV2(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_code,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_INTRA_DJ: async () => {
    const API = carController()
    const res = await API.getBrandIntraDj()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make,
          text: e.make,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_INTRA_DJ: async (brand) => {
    const API = carController()
    const res = await API.getSeriesIntraDj(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model,
          text: e.model,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_Jaymart: async () => {
    const API = carController()
    const res = await API.getBrandJaymart()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          no: e.id,
          value: e.code,
          text: e.description,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_Jaymart: async (brand) => {
    const API = carController()
    const res = await API.getSeriesJaymartByName(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.code,
          text: e.description,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_THAISRI_INS: async () => {
    const API = carController()
    const res = await API.getBrandThaisriIns()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_code,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_YEAR_THAISRI_INS: async (brand) => {
    const API = carController()
    const res = await API.getYearThaisriIns(brand)
    if (isValidResponse(res)) {
      const year = res.result
      const yearOption = year.map((e) => {
        return {
          value: e.model_year,
          text: e.model_year,
        }
      })
      return yearOption
    }
  },
  CAR_SERIES_THAISRI_INS: async (brand, year) => {
    const API = carController()
    const res = await API.getSeriesThaisriByNameIns(brand, year)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_code,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_THAISRI_INS: async (brand, series, year) => {
    const API = carController()
    const res = await API.getSubSeriesThaisriByNameIns(brand, series, year)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const seriesOption = subSeries.map((e) => {
        return {
          code: e.sub_model_code,
          value: e.sub_model_name,
          text: e.sub_model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_THAISRI: async () => {
    const API = carController()
    const res = await API.getBrandThaisri()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_name,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_THAISRI: async (brand) => {
    const API = carController()
    const res = await API.getSeriesThaisriByName(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_name,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_THAISETAKIJ: async () => {
    const API = carController()
    const res = await API.getBrandThaiSetakij()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_code,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_THAISETAKIJ: async (brand) => {
    const API = carController()
    const res = await API.getSeriesThaiSetakij(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_code,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_DHIPAYA: async () => {
    const API = carController()
    const res = await API.getBrandDhipaya()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_code,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_DHIPAYA: async (brand) => {
    const API = carController()
    const res = await API.getSeriesDhipayaByName(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_code,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_DHIPAYA: async (series) => {
    const API = carController()
    const res = await API.getSubSeriesDhipayaByName(series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const seriesOption = subSeries.map((e) => {
        return {
          code: e.sub_model_code,
          value: e.sub_model_name,
          text: e.sub_model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_KWI: async () => {
    const API = carController()
    const res = await API.getBrandKwi()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_name,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_KWI: async (brand) => {
    const API = carController()
    const res = await API.getSeriesKwi(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_name,
          text: e.model_name,
          seat: e.seat,
        }
      })
      return seriesOption
    }
  },
  NATIONALKWI: async () => {
    const API = defaultController()
    const res = await API.getNationalKwi()
    if (isValidResponse(res)) {
      const list = res.result.map((e, i) => {
        return {
          key: i,
          text: `${e.nationality_th}`,
          value: e.nationality_code,
        }
      })
      return list
    }
  },
  CAR_BRAND_DD: async () => {
    const API = carController()
    const res = await API.getBrandComdd()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_name,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_DD: async (brand) => {
    const API = carController()
    const res = await API.getSeriesComdd(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_name,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_DD: async (brand, series) => {
    const API = carController()
    const res = await API.getSubseriesComdd(brand, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.SubModel,
          text: e.SubModel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_CHUBB: async () => {
    const API = carController()
    const res = await API.getBrandChubb()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_name,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_YEAR_CHUBB: async (brand) => {
    const API = carController()
    const res = await API.getYearsChubb(brand)
    if (isValidResponse(res)) {
      const years = res.result
      const yearOption = years.map((e) => {
        return {
          value: e.year,
          text: e.year,
        }
      })
      return yearOption
    }
  },
  CAR_SERIES_CHUBB: async (brand, year) => {
    const API = carController()
    const res = await API.getSeriesChubb(brand, year)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_name,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_RVP: async () => {
    const API = carController()
    const res = await API.getBrandRVP()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandOption = brands.map((e) => {
        return {
          value: e.make_name,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_SERIES_RVP: async (brand) => {
    const API = carController()
    const res = await API.getBrandRVP()
    if (isValidResponse(res)) {
      const brands = res.result.filter((e) => e.make_name === brand)
      const brandOption = brands.map((e) => {
        return {
          value: e.make_name,
          text: e.make_name,
        }
      })
      return brandOption
    }
  },
  CAR_BRAND_VIRIYA_INS: async () => {
    const API = carController()
    const res = await API.getBrandViriyaIns()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.brand,
          text: e.brand,
        }
      })
      return brandsOption
    }
  },
  CAR_YEAR_VIRIYA_INS: async (brand) => {
    const API = carController()
    const res = await API.getYearViriyaIns(brand)
    if (isValidResponse(res)) {
      const years = res.result
      const yearOption = years.map((e) => {
        return {
          value: e.year,
          text: e.year,
        }
      })
      return yearOption
    }
  },
  CAR_SERIES_VIRIYA_INS: async (brand) => {
    const API = carController()
    const res = await API.getSeriesViriyaIns(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model,
          text: e.model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_VIRIYA_INS: async (brand, series) => {
    const API = carController()
    const res = await API.getSubseriesViriyaIns(brand, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.submodel,
          text: e.submodel,
          code: e.submodel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_FCI: async () => {
    const API = carController()
    const res = await API.getBrandFci()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.Make,
          text: e.Make,
        }
      })
      return brandsOption
    }
  },
  CAR_SERIES_FCI: async (brand) => {
    const API = carController()
    const res = await API.getSeriesFci(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.Model,
          text: e.Model,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_FCI_INS: async () => {
    const API = carController()
    const res = await API.getBrandFciIns()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.Make,
          text: e.Make,
        }
      })
      return brandsOption
    }
  },
  CAR_YEAR_FCI_INS: async (brand) => {
    const API = carController()
    const res = await API.getYearFciIns(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.YearModel,
          text: e.YearModel,
        }
      })
      return seriesOption
    }
  },
  CAR_SERIES_FCI_INS: async (brand, year) => {
    const API = carController()
    const res = await API.getSeriesFciIns(brand, year)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.Model,
          text: e.Model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_FCI_INS: async (brand, year, series) => {
    const API = carController()
    const res = await API.getSubseriesFciIns(brand, year, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.SubModel,
          text: e.SubModel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_TPB: async () => {
    const API = carController()
    const res = await API.getBrandTpb()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.make_code,
          text: e.make_name,
        }
      })
      return brandsOption
    }
  },
  CAR_SERIES_TPB: async (brand) => {
    const API = carController()
    const res = await API.getSeriesTpb(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model_code,
          text: e.model_name,
        }
      })
      return seriesOption
    }
  },
  CAR_BRAND_VIRIYA_V2: async () => {
    const API = carController()
    const res = await API.getBrandViriyaV2()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.brand,
          text: e.brand,
        }
      })
      return brandsOption
    }
  },
  CAR_YEAR_VIRIYA_V2: async (brand) => {
    const API = carController()
    const res = await API.getYearViriyaV2(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.registration_year,
          text: e.registration_year,
        }
      })
      return seriesOption
    }
  },
  CAR_SERIES_VIRIYA_V2: async (brand, year) => {
    const API = carController()
    const res = await API.getSeriesViriyaV2(brand, year)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model,
          text: e.model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_VIRIYA_V2: async (brand, series, year) => {
    const API = carController()
    const res = await API.getSubSeriesViriyaV2(brand, series, year)
    if (isValidResponse(res)) {
      const subSeries = res.result.filter((e) => e.submodel)
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.submodel,
          text: e.submodel,
          code: e.submodel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_VIRIYA_CMI: async () => {
    const API = carController()
    const res = await API.getBrandViriyaCmi()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.brand,
          text: e.brand,
        }
      })
      return brandsOption
    }
  },
  CAR_SERIES_VIRIYA_CMI: async (brand) => {
    const API = carController()
    const res = await API.getSeriesViriyaCmi(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model,
          text: e.model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_VIRIYA_CMI: async (brand, series) => {
    const API = carController()
    const res = await API.getSubSeriesViriyaCmi(brand, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.submodel,
          text: e.submodel,
          code: e.submodel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_DVS_CMI: async () => {
    const API = carController()
    const res = await API.getBrandDvsCmi()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.carBrand,
          text: e.carBrand,
        }
      })
      return brandsOption
    }
  },
  CAR_SERIES_DVS_CMI: async (brand) => {
    const API = carController()
    const res = await API.getSeriesDvsCmi(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.carModel,
          text: e.carModel,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_DVS_CMI: async (brand, series) => {
    const API = carController()
    const res = await API.getSubSeriesDvsCmi(brand, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.subModel,
          text: e.subModel,
        }
      })
      return subSeriesOption
    }
  },
  CAR_BRAND_DVS_INS: async () => {
    const API = carController()
    const res = await API.getBrandDvsIns()
    if (isValidResponse(res)) {
      const brands = res.result
      const brandsOption = brands.map((e) => {
        return {
          value: e.make,
          text: e.make,
        }
      })
      return brandsOption
    }
  },
  CAR_SERIES_DVS_INS: async (brand) => {
    const API = carController()
    const res = await API.getSeriesDvsIns(brand)
    if (isValidResponse(res)) {
      const series = res.result
      const seriesOption = series.map((e) => {
        return {
          value: e.model,
          text: e.model,
        }
      })
      return seriesOption
    }
  },
  CAR_SUB_SERIES_DVS_INS: async (brand, series) => {
    const API = carController()
    const res = await API.getSubSeriesDvsIns(brand, series)
    if (isValidResponse(res)) {
      const subSeries = res.result
      const subSeriesOption = subSeries.map((e) => {
        return {
          value: e.subModel,
          text: e.subModel,
        }
      })
      return subSeriesOption
    }
  },
  INSURE_TYPE: async () => {
    const type = [
      {
        text: 'ชั้น 2+ ซ่อมอู่',
        value: 'ชั้น 2+ ซ่อมอู่',
        type: '2+',
        repairType: 'ซ่อมอู่',
      },
      // {
      // 	text: 'ชั้น 2 ซ่อมอู่',
      // 	value: 'ชั้น 2 ซ่อมอู่',
      // 	type: '2',
      // 	repairType: 'ซ่อมอู่',
      // },
      {
        text: 'ชั้น 3+ ซ่อมอู่',
        value: 'ชั้น 3+ ซ่อมอู่',
        type: '3+',
        repairType: 'ซ่อมอู่',
      },
      {
        text: 'ชั้น 3 ซ่อมอู่',
        value: 'ชั้น 3 ซ่อมอู่',
        type: '3',
        repairType: 'ซ่อมอู่',
      },
    ]
    const insureTypeObj = type.map((e, i) => {
      return {
        key: e.i,
        value: e.value,
        text: e.label,
        type: e.type,
        repairType: e.repairType,
      }
    })
    return insureTypeObj.sort((a, b) => a.value - b.value)
  },
  CAR_CODE: async () => {
    const API = defaultController()
    const res = await API.getAutoScene()
    if (isValidResponse(res)) {
      const autoScene = res.result.idcar
      const autoSceneObj = autoScene
        .filter(
          (e) =>
            ![
              '320.1',
              '420',
              '520',
              '540',
              '620',
              '620E',
              '630',
              '730',
            ].includes(e.value) &&
            !(e.value === '210' && e.label === '(210)-รถกระบะ-ส่วนบุคคล'),
        )
        .map((e, i) => {
          return {
            key: i,
            value: e.value,
            text: e.label,
          }
        })
      return autoSceneObj.sort((a, b) => a.value - b.value)
    }
  },
  INSTALLMENT: (amount, carCode, protectedDate) => {
    if (carCode !== '730') {
      return [
        { key: 0, value: 'full', text: 'จ่ายเต็ม' },
        // {
        // 	key: 1,
        // 	value: '3',
        // 	text: `ผ่อน 3 งวด ${
        // 		installmentPrice('3', amount, carCode, protectedDate)?.otherMonth
        // 	}`,
        // },
        // {
        // 	key: 2,
        // 	value: '6',
        // 	text: `ผ่อน 6 งวด ${
        // 		installmentPrice('6', amount, carCode, protectedDate)?.otherMonth
        // 	}`,
        // },
        // {
        // 	key: 3,
        // 	value: '8',
        // 	text: `ผ่อน 8 งวด ${
        // 		installmentPrice('8', amount, carCode, protectedDate)?.otherMonth
        // 	}`,
        // },
        // {
        // 	key: 4,
        // 	value: '10',
        // 	text: `ผ่อน 10 งวด ${
        // 		installmentPrice('10', amount, carCode, protectedDate)?.otherMonth
        // 	}`,
        // },
      ]
    }
    return [
      { key: 0, value: 'full', text: 'จ่ายเต็ม' },
      // {
      // 	key: 1,
      // 	value: '3',
      // 	text: `ผ่อน 3 งวด ${
      // 		installmentPrice('3', amount, carCode, protectedDate)?.otherMonth
      // 	}`,
      // },
      // {
      // 	key: 2,
      // 	value: '6',
      // 	text: `ผ่อน 6 งวด ${
      // 		installmentPrice('6', amount, carCode, protectedDate)?.otherMonth
      // 	}`,
      // },
    ]
  },
  VIF_ACTIVE: async () => {
    const API = userController()
    const res = await API.getVifActive()
    if (isValidResponse(res)) {
      const { result } = res
      const list = result.map((e, i) => {
        return {
          key: i + 1,
          value: e.cuscode,
          text: e.name,
        }
      })
      return list
    }
  },
  PROVINCES: async () => {
    const API = addressController()
    const res = await API.getProvinces()
    if (isValidResponse(res)) {
      const result = res.result.onlyProvinces
      const list = result.map((e) => {
        return {
          value: e.province,
          text: e.province,
        }
      })
      return list
    } else {
      return []
    }
  },
  ALL_COUNT_LOT: async () => {
    const API = systemController()
    const res = await API.getAllCountLot()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e) => {
        return {
          value: e.import_file_count,
          text: e.import_file_count,
        }
      })
      console.log(list)
      return list
    }
  },
  SERVICE_LIST: async () => {
    const API = productController()
    const res = await API.getListService()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          name: e.name,
          value: e.code_product,
          price: e.price,
        }
      })
      return list
    }
  },
  COLORCARDD: async () => {
    const API = colorController()
    const res = await API.getColorDd()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: e.Name_TH,
          value: e.Name_TH,
        }
      })
      return list
    }
  },
  COUNTRYAXA: async () => {
    const API = defaultController()
    const res = await API.getCountryDj()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: `${e.name_EN} / ${e.name_TH}`,
          value: e.code,
        }
      })
      return list
    }
  },
  NATIONALAXA: async () => {
    const API = defaultController()
    const res = await API.getNationalityDj()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: `${e.name_EN} / ${e.name_TH}`,
          value: e.code,
        }
      })
      return list
    }
  },
  COLORCARTHAISRI: async () => {
    const API = colorController()
    const res = await API.getColorThaisri()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: e.name_TH,
          value: e.name_TH,
        }
      })
      return list
    }
  },
  COUNTRYTHAISRI: async () => {
    const API = defaultController()
    const res = await API.getCountryThaisri()

    if (isValidResponse(res)) {
      const list = res.result.map((e, i) => {
        return {
          key: i,
          text: `${e.name_EN} / ${e.name_TH}`,
          value: e.code,
        }
      })
      return list
    }
  },
  NATIONALTHAISRI: async () => {
    const API = defaultController()
    const res = await API.getNationalThaisri()
    if (isValidResponse(res)) {
      const list = res.result.map((e, i) => {
        return {
          key: i,
          text: `${e.name_EN} / ${e.name_TH}`,
          value: e.code,
        }
      })
      return list
    }
  },
  COLORCARRVP: async () => {
    const API = colorController()
    const res = await API.getColorRvp()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: e.name_TH,
          value: e.name_TH,
        }
      })
      return list
    }
  },
  COLORCARFCI: async () => {
    const API = colorController()
    const res = await API.getColorFCI()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: e.name_TH,
          value: e.name_TH,
        }
      })
      return list
    }
  },
  COLORCARVIRIYA: async () => {
    const API = colorController()
    const res = await API.getColorViriya()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: e.color_name_th,
          value: e.color_name_th,
        }
      })
      return list
    }
  },
  COLORCARDVS: async () => {
    const API = colorController()
    const res = await API.getColorDvs()
    if (isValidResponse(res)) {
      const data = await res.result
      const list = data.map((e, i) => {
        return {
          key: i,
          text: e.DescThai,
          value: e.DescThai,
        }
      })
      return list
    }
  },
}
